export const CATEGORY_CONFIG = {
    // lower number --> higher priority
    ticker: {
        order: 0,
        showHeader: false,
        highlightPrefix: false,
    },
    suggestion: {
        order: 1,
        showHeader: false,
        highlightPrefix: true,
    },
    news: {
        displayName: 'Latest News',
        order: 2,
        showHeader: true,
        highlightPrefix: false,
    },
    related_question: {
        displayName: 'Related Questions',
        order: 3,
        showHeader: true,
        highlightPrefix: false,
    },
    shortcuts: {
        displayName: 'Shortcuts',
        order: 4,
        showHeader: true,
        highlightPrefix: true,
    },
};
export const groupSuggestionsByCategory = (suggestions) => {
    const groups = {};
    suggestions.forEach((suggestion) => {
        const category = suggestion.category || 'suggestion';
        if (!groups[category]) {
            groups[category] = [];
        }
        groups[category].push(suggestion);
    });
    return groups;
};
export const getSortedCategories = (groupedSuggestions) => {
    return Object.keys(groupedSuggestions).sort((a, b) => {
        const orderA = CATEGORY_CONFIG[a]?.order ?? Number.MAX_SAFE_INTEGER;
        const orderB = CATEGORY_CONFIG[b]?.order ?? Number.MAX_SAFE_INTEGER;
        return orderA - orderB;
    });
};
const hasValidTickerMetadata = (suggestion) => {
    const { metadata } = suggestion;
    return (!!metadata &&
        metadata.type === 'price' &&
        !!metadata.price_info &&
        typeof metadata.price_info.currentPrice === 'number' &&
        !!metadata.price_info.change &&
        !!metadata.price_info.changePercentage);
};
export const sortTickerSuggestions = (suggestions) => {
    return [...suggestions].sort((a, b) => {
        const aHasValidMetadata = hasValidTickerMetadata(a);
        const bHasValidMetadata = hasValidTickerMetadata(b);
        if (aHasValidMetadata && !bHasValidMetadata)
            return -1;
        if (!aHasValidMetadata && bHasValidMetadata)
            return 1;
        return 0;
    });
};
//# sourceMappingURL=SuggestCategoriesShared.js.map